<script>
    import {pad0} from "../js/utils.js";
    import {clickOutside} from '../js/clickOutside.js';
    import Icon from "../components/icons/Icon.svelte";

    export let id = "time_control";
    export let value = null;
    export let required = false;

    let hour = "";
    let minute = "";
    let show_dropdown = false;

    function getTime(d) {
        const dt = d ? (d instanceof Date ? d : new Date(d)) : new Date();
        return `${pad0(dt.getHours())}:${pad0(dt.getMinutes())}`;
    }

    function set_time(v) {
        if (v) {
            value = getTime(v);
            [hour, minute] = value.split(":");
        }
    }

    const set_current_time = () => {
        const now = new Date();
        value = `${pad0(now.getHours())}:${pad0(now.getMinutes())}`;
        [hour, minute] = value.split(":");
    }

    function showDropdown() {
        if (!hour || !minute) {
            if (value) {
                [hour, minute] = value.split(":");
            } else {
                hour = "00";
                minute = "00";
            }
        }

        setTimeout(() => {
            show_dropdown = true;
        }, 200);
    }

    function hideDropdown() {
        show_dropdown = false;
    }

    function hour_up() {
        if (!value) {
            set_current_time();
        }

        let v = parseInt(hour || "0", 10) + 1;
        if (v > 23) v = 0;
        hour = pad0(v);
        value = `${hour}:${minute}`;
    }

    function hour_down() {
        if (!value) {
            set_current_time();
        }

        let v = parseInt(hour || "0", 10) - 1;
        if (v < 0) v = 23;
        hour = pad0(v);
        value = `${hour}:${minute}`;
    }

    function minute_up() {
        if (!value) {
            set_current_time();
        }

        let v = parseInt(minute || "0", 10) + 10;
        if (v > 59) v = 0;
        minute = pad0(v);
        value = `${hour}:${minute}`;
    }

    function minute_down() {
        if (!value) {
            set_current_time();
        }

        let v = parseInt(minute || "0", 10) - 10;
        if (v < 0) v = 50;
        minute = pad0(v);
        value = `${hour}:${minute}`;
    }

    $: if (hour && minute) {
        value = `${hour}:${minute}`;
    }
</script>

<div class="time-control time-control-root">
    <input
            type="text"
            class="form-control book-control"
            {id}
            value={value}
            on:focusin={showDropdown}
            autocomplete="off"
            {required}
            readonly
    />

    {#if show_dropdown}
        <div class="time-dropdown" use:clickOutside on:click_outside={hideDropdown}>
            <div class="content">
                <div class="digit">
                    <button type="button" class="btn time-nav" on:click={hour_up}>
                        <Icon name="chevron-up" size="18"/>
                    </button>
                    {hour}
                    <button type="button" class="btn time-nav" on:click={hour_down}>
                        <Icon name="chevron-down" size="18"/>
                    </button>
                </div>

                <div>:</div>

                <div class="digit">
                    <button type="button" class="btn time-nav" on:click={minute_up}>
                        <Icon name="chevron-up" size="18"/>
                    </button>
                    {minute}
                    <button type="button" class="btn time-nav" on:click={minute_down}>
                        <Icon name="chevron-down" size="18"/>
                    </button>
                </div>
            </div>

            <button type="button" class="btn btn-default btn-sm d-block w-100 mt-1" on:click={hideDropdown}>
                OK
            </button>
        </div>
    {/if}
</div>

<style>
    .time-control {
        position: relative;
    }

    .time-control .time-dropdown {
        position: absolute;
        width: max-content;
        background: #fefefe;
        box-shadow: 0 7px 15px rgba(0, 0, 0, .25);
        border-radius: 1px;
        padding: 10px;
        z-index: 9000;
    }

    .time-control .time-dropdown .content {
        display: flex;
        align-items: center;
        font-size: 20px;
    }

    .time-control .time-dropdown .digit {
        width: 50px;
        text-align: center;
    }

    .time-control .time-dropdown .digit .time-nav {
        display: block;
        width: 100%;
        color: #01b3a7;
        padding: 5px 0;
    }

    .time-control .time-dropdown .digit .time-nav:hover {
        background-color: #eee;
    }

    .time-control .form-control[readonly] {
        background-color: #fff;
    }
</style>
